import { ReactNode } from "react";

/**
 * A bordered card used to group a Settings sub-section (e.g. Company
 * Information, Policy Lookup Credentials) behind its own header. Always
 * visible — the page's left-hand nav scrolls to a section rather than
 * expanding/collapsing it.
 */
const SettingsSection = ({
  id,
  title,
  subtitle,
  headerAction,
  children,
}: {
  id?: string;
  title: string;
  subtitle?: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
}) => {
  return (
    <section
      id={id}
      className="border border-gray-200 rounded-lg bg-white scroll-mt-8"
    >
      <div className="p-6 border-b border-gray-200 flex items-start justify-between">
        <div>
          <h2 className="text-lg font-semibold">{title}</h2>
          {subtitle && (
            <div className="text-sm text-gray-500 mt-1">{subtitle}</div>
          )}
        </div>
        {headerAction}
      </div>
      <div className="p-6">{children}</div>
    </section>
  );
};

export default SettingsSection;
